
import { PlanListFilerActions, PlanListFilerActionTypes } from '../actions/plan-list-filer.actions';

export interface State {
  platformOptions: number;
  statusOptions: number;
}

export const initialState: State = {
  platformOptions: -1,
  statusOptions: -1
};

export function reducer(state = initialState, action: PlanListFilerActions): State {
  switch (action.type) {

    case PlanListFilerActionTypes.LoadPlanListFilers:
      return {...state,
      platformOptions: action.payload.Platform,
      statusOptions: action.payload.Status};

    default:
      return state;
  }
}
